import { render, staticRenderFns } from "./HeadingImageNews.vue?vue&type=template&id=01e49dca&"
import script from "./HeadingImageNews.vue?vue&type=script&lang=js&"
export * from "./HeadingImageNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports